import styled from "styled-components/macro";
import { Telephone } from "../../assets/iconComponents/Telephone";
import { Email } from "../../assets/iconComponents/Email";
import { Fax } from "../../assets/iconComponents/Fax";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

const getFooterPadding = (deviceType?: DeviceType) => {
  if (deviceType === "mobile") {
    return "32px 24px 24px 24px";
  }
  if (deviceType === "tablet") {
    return "40px 45px 32px 45px";
  }
  return "48px 80px 32px 80px";
};

export const FooterStyled = styled.div<{
  deviceType: DeviceType;
}>`
  background-color: ${({ theme }) => theme.neutralBackground};
  text-align: left;
  height: auto;
  padding: ${({ deviceType }) => getFooterPadding(deviceType)};

  a {
    text-decoration: none;
  }
`;

export const BabyPeekFooterStyled = styled.div<{
  deviceType: DeviceType;
}>`
  background-color: #1a202c;
  grid-gap: 24px;
  justify-content: center;
  align-items: center;

  display: grid;
  padding: 60px 24px 40px 24px;

  hr {
    height: 4px;
    border: 0;
    border-top: 1px solid #edf2f7;
    margin: 16px 0px;
    padding: 0px 25px;
    width: calc(100% - 10px);
    justify-self: center;
  }
`;

export const BabyPeekFooterItem = styled.div`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24.3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #edf2f7;
  a {
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24.3px;
    text-align: left;
    color: #edf2f7;
  }

  svg {
    margin-right: 10px;
    margin-left: 10px;
  }

  path {
    fill: #edf2f7;
  }
`;

export const FooterUnityContainer = styled.div<{
  isDesktop: boolean;
}>`
  display: flex;
  align-items: center;
  padding-bottom: ${({ isDesktop }) => (isDesktop ? "24px" : "32px")};
`;

export const FooterUnityImage = styled.img`
  display: block;
  height: 28px;
  width: auto;
`;

export const FooterContactContainer = styled.div<{
  deviceType: DeviceType;
}>`
  display: inline-grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: ${({ deviceType }) =>
    deviceType === "desktop" ? "15px 0 10px 0" : "30px 0 10px 0"};
`;

export const FooterDesktopContactContainer = styled.div`
  display: grid;
`;

export const FooterSocialContainer = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto auto;
  grid-gap: 33px;
  padding-top: 15px;
  &:hover {
    svg {
      cursor: pointer;
    }
  }
`;

export const FooterLinksContainer = styled.div<{
  deviceType: DeviceType;
}>`
  display: ${({ deviceType }) => (deviceType === "desktop" ? "flex" : "grid")};
  grid-template-columns: ${({ deviceType }) =>
    deviceType === "desktop" ? "none" : "1fr 1fr"};
  flex-wrap: wrap;
  gap: ${({ deviceType }) =>
    deviceType === "desktop" ? "16px 32px" : "0 16px"};
  padding: 0;

  ${({ deviceType }) =>
    deviceType !== "desktop" &&
    `
    > a {
      min-height: 40px;
      display: flex;
      align-items: center;
    }
  `}
`;

export const FooterLegalContainer = styled.div<{
  isDesktop: boolean;
}>`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 4px;
  padding-top: ${({ isDesktop }) => (isDesktop ? "32px" : "16px")};

  p {
    padding: 0 !important;
  }
`;

export const FooterPrivacyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 4px;
`;

export const FooterAccreditationContainerDesktop = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 6px;
`;

export const FooterAccredContainerNotDesktop1 = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 4px;
`;

export const FooterAccredContainerNotDesktop2 = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 4px;
`;

export const FooterHr = styled.hr`
  border: 1px solid ${({ theme }) => theme.neutral300};
  margin: 25px 0px 25px 0px;
`;

export const FooterPaddedTelephone = styled(Telephone)`
  margin-top: 1px;
`;

export const FooterPaddedEmail = styled(Email)`
  margin-top: 2px;
`;

export const FooterPaddedFax = styled(Fax)`
  margin-top: 1px;
`;
